import { useSelector } from 'react-redux'
import styled, { useTheme } from 'styled-components'
import colors from '../../configuration/colors'
import { getCurrentYear } from '../../utils/date'
import LogoSvg from '../../static/images/branding/OE_QuestForwardLearning_H_forLite_RGB.svg'
import DarkLogoSvg from '../../static/images/branding/darkThemeLogo.svg'
import BellevueLogoSvg from '../../static/images/branding/bellevue/bu-logo-horizontal.png'
import { P3, Caption1 } from '../styled/typography/typography'

const FooterWrapper = styled.footer`
  // hide when sending to printer
  @media print {
    display: none;
  }

  position: relative;
  width: 100%;
  height: 120px;
  bottom: 0;
  left: 0;
  padding: 0 20px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  background: ${({ theme }) => theme.footerBackground};
  z-index: 11;

  .footer-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    height: 100%;
  }

  .right {
    width: auto;
    text-align: right;
  }

  .copyright {
    float: right;
  }

  .copyright {
    .ourpolicies {
      display: inline-block;
      padding-left: 6px;
      cursor: pointer;
      color: ${({ theme }) => theme.caption3color};
      font-weight: 500;

      &:hover {
        color: ${colors.dove};
      }
    }
  }
`

const darkLogo = styled.img.attrs({
  src: DarkLogoSvg
})`
  height: auto;
  width: 250px;
`

const Logo = styled.img.attrs({
  src: LogoSvg
})`
  height: auto;
  width: 250px;
`

const BellevueLogo = styled.img.attrs({
  src: BellevueLogoSvg
})`
  height: auto;
  width: 250px;
`

export const Copyright = styled(Caption1)`
  line-height: 18px;
`

const Footer = () => {
  const theme = useTheme()
  const { isMentor, isAuthenticated } = useSelector(state => state.auth)
  const orgId = useSelector(state => state.organization.orgId)
  const TheLogo = orgId !== 149
      ? theme?.style === 'dark'
        ? darkLogo
        : Logo
      : BellevueLogo

  const url =
    orgId !== 149
      ? 'https://www.opportunityeducation.org'
      : 'https://bellevue.edu'
  const alt =
    orgId !== 149
      ? 'Opportunity Education and Quest Forward Learning&trade;'
      : 'Bellevue University'
  return (
    <FooterWrapper className={!isAuthenticated ? 'hidden' : ''}>
      {isAuthenticated && (
        <div className="footer-wrapper">
          <div className="left">
            <a href={url} target="_blank">
              <TheLogo alt={alt} />
            </a>
          </div>
          <div className="right">
            <Copyright className="copyright">
              {`© 2012-${getCurrentYear()} Opportunity Education Foundation, Inc.`}
              <br />
              Quest Forward Learning&trade; | All rights reserved. |{' '}
              <Caption1 as="a" className="ourpolicies" href="/ourpolicies">
                Our Policies
              </Caption1>
            </Copyright>
          </div>
        </div>
      )}
    </FooterWrapper>
  )
}

export default Footer
